export function formatDeviceKey(device_id: string, session_id?: string | null) {
  const sessionPart = session_id ? `-${session_id}` : '-current';
  return `${device_id}${sessionPart}`;
}

export function parseDeviceKey(key: string) {
  const [device_id, session_id] = key.split('-');
  return {
    device_id,
    session_id: session_id === 'current' ? null : session_id,
  };
}
